import { render } from "./imageShow.vue?vue&type=template&id=046dd054&scoped=true"
import script from "./imageShow.vue?vue&type=script&lang=js"
export * from "./imageShow.vue?vue&type=script&lang=js"

import "./imageShow.vue?vue&type=style&index=0&id=046dd054&scoped=true&lang=css"

import exportComponent from "/home/wido/Documents/Project/SS-GreedGreed/ss-web-app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-046dd054"]])

export default __exports__